import { GISCreditTypes } from './gis';

export class GISAddons {
    Products: GISAddonProductBasicArray;
    Licenses: LicenseBasicArray;
    Member: GISAddonPayMember;
}

export class GISAddonPayMember {    
    MemberID: number;
    FullName: string;   
    TaxPercent: number;
    State: string;
}

export class LicenseBasic {
    LicenseID: number;
    LicenseKey: string;
    MemberID: number;
    MemberFullName: string;
    IsDesigner: boolean;
    HasSubscription:boolean; 
}

export class GISAddonProductBasic {
    ID: number;
    Name: string;
    Description: string;
    Credits: number;
    Price: number;
    TaxPercent: number;
    Tax: number;
    Total: number;
    SubscriptionDiscountPrice: number;
    TaxSubscriptionDiscountPrice: number;
    TotalSubscriptionDiscountPrice: number;
}

export class GISAddonProductBasicArray extends Array<GISAddonProductBasic>  {

    constructor(...items: GISAddonProductBasic[]) {
        super(...items);
        Object.setPrototypeOf(this, GISAddonProductBasicArray.prototype);
    }

}

export class LicenseBasicArray extends Array<LicenseBasic>  {

    constructor(...items: LicenseBasic[]) {
        super(...items);
        Object.setPrototypeOf(this, LicenseBasicArray.prototype);
    }
}


export class GISProductItem {
    ProductID: number;
    Name: string;
    Credits: number;
    Price: number;
    GisType: GISCreditTypes;

    TaxRateDisplay: string;
    TaxRate: number;
    TaxAmount: number;
    TotalWithTax: number;
    State: string;
}

export class GISProductItemArray extends Array<GISProductItem>  {

    constructor(...items: GISProductItem[]) {
        super(...items);
        Object.setPrototypeOf(this, GISProductItemArray.prototype);
    }

}

export class GISAddonProductItem {
    ProductID: number;
    Description: string;
    ProductQuantity: number;
    FullPrice: number;    
    Title: string;
    Footer: string;
    PayType: number;
}

export class GISAddonProductItemArray extends Array<GISAddonProductItem>  {

    constructor(...items: GISAddonProductItem[]) {
        super(...items);
        Object.setPrototypeOf(this, GISProductItemArray.prototype);
    }

}
